import React from 'react';
import { Modal, Header } from 'semantic-ui-react';
import GenericCRUForm from './GenericCRUForm';

const CRUModal = ({
                      isOpen,
                      onClose,
                      title,
                      description,
                      data,
                      fields,
                      onSave,
                      mode,
                      loading,
                      error,
                      buttonLabels
                  }) => (
    <Modal open={isOpen} onClose={onClose} size="small" closeIcon className="right-side-modal" dimmer={false}>
        <Modal.Header>
            <Header as='h3' content={title} />
            {description && <Header.Subheader content={description} />}
        </Modal.Header>
        <Modal.Content>
            <GenericCRUForm
                title={title}
                data={data}
                fields={fields}
                onSave={onSave}
                onCancel={onClose}
                mode={mode}
                loading={loading}
                error={error}
                buttonLabels={buttonLabels}

            />
        </Modal.Content>
    </Modal>
);

export default CRUModal;